<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="computedHeight" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 半环形饼图
	export default {
		name: 'PersonDonutChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true
			},
			title: {
				type: String,
				default: ''
			},
			// 是否显示图例
			showLegend: {
				type: Boolean,
				default: true
			},
			// 图例位置
			legendPosition: {
				type: String,
				default: 'bottom'
			},
			// 中心显示的文本
			centerText: {
				type: [String, Number],
				default: ''
			},
			// 中心文本下方的单位或描述
			centerSubText: {
				type: String,
				default: ''
			},
			// 颜色列表
			colorList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				defaultChartHeight: 250, // 默认图表高度
				legendItemHeight: 20, // 每个图例项的高度
				legendPadding: 20 // 图例区域内边距
			}
		},
		computed: {
			// 计算总数
			total() {
				return this.chartData.reduce((sum, item) => sum + item.value, 0)
			},

			// 计算图表高度
			computedHeight() {
				// 基础高度
				let baseHeight = this.defaultChartHeight

				// 当图例位置在底部且数据超过一定数量时，增加高度
				if (this.showLegend && this.legendPosition === 'bottom' && this.chartData.length > 5) {
					// 计算需要的额外行数 (每行显示5个图例)
					const extraRows = Math.ceil(this.chartData.length / 3) - 1
					// 为每行增加高度
					baseHeight += extraRows * this.legendItemHeight + this.legendPadding
				}

				return `${baseHeight}px`
			},

			chartOptions() {
				return {
					title: this.title
						? {
								text: this.title,
								left: 'center',
								top: 0,
								textStyle: {
									fontSize: 16,
									fontWeight: 'normal'
								}
						  }
						: null,
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: this.showLegend
						? {
								orient: 'horizontal',
								bottom: '0',
								icon: 'circle',
								itemWidth: 10,
								itemHeight: 10,
								textStyle: {
									fontSize: 12
								}
						  }
						: null,
					color:
						this.colorList.length > 0
							? this.colorList
							: [
									'#1890ff', // 蓝色
									'#13c2c2', // 青色
									'#722ed1', // 紫色
									'#fa8c16', // 橙色
									'#8c8c8c' // 灰色
							  ],
					series: [
						{
							name: this.title || '数据分布',
							type: 'pie',
							radius: ['45%', '65%'], // 内外半径，形成环形
							center: ['50%', '40%'],
							startAngle: 360, // 起始角度设为360度，形成半环
							endAngle: 0, // 结束角度设为0度
							avoidLabelOverlap: true,
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							data: this.chartData
						},
						// 添加一个隐藏的半环，用于补全图形
						{
							name: '',
							type: 'pie',
							radius: ['45%', '65%'],
							center: ['50%', '40%'],
							startAngle: 0, // 从0度开始
							endAngle: -360, // 到-3600度结束
							silent: true, // 不响应鼠标事件
							label: {
								show: false
							},
							labelLine: {
								show: false
							},
							itemStyle: {
								color: 'rgba(0, 0, 0, 0.05)' // 灰色半透明
							},
							data: [{ value: 1, name: '' }]
						}
					],
					// 添加中心文本
					graphic: [
						{
							type: 'text',
							left: '42%',
							top: '35%',
							style: {
								text: this.centerText || this.total.toString(),
								fontSize: 30,
								fontWeight: 'bold',
								textAlign: 'center',
								fill: '#333'
							}
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
